module.exports = __webpack_public_path__ + "static/media/java-development.4b3741f8.png";